import styled from 'styled-components';

export const ImgWrapper = styled.div`
  margin-top: 50px;
  @media screen and (max-width: 450px) {
    margin-top: 10px;
  }
`;
export const StyledImage = styled.img`
  max-width: 100%;
`;

export const StyledItem = styled.li`
  width: 76px;
  height: 76px;
  background-color: ${({ active }) =>
        active ? '#00BFA5' : '#FFFFFF'};
  border: ${({ active }) =>
        active
            ? '1px solid #FFFFFF'
            : '1px solid #00BFA5'};
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ active }) =>
        active ? '#FFFFFF' : '#323232'};
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  cursor: pointer;
  margin-right: 8px;
  &:focus {
    outline: none;
  }
  :last-child {
    margin-right: 0px;
    ::after {
      content: attr(data-text);
      position: absolute;
      width: 80px;
      bottom: -30px;
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      color: #323232;
      text-align: center;
    }
  }
  `;

export const Title = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #323232;
  text-align: center;
  margin-bottom: 12px;
  @media screen and (max-width: 450px) {
    margin-bottom: 10px;
  }
`;

export const Description = styled.p`
  max-width: 460px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #323232;
  text-align: center;
  margin-bottom: 16px;
  @media screen and (max-width: 450px) {
    max-width: 330px;
    margin-bottom: 10px;
  }
`;

export const Cost = styled.div`
  max-width: 460px;
  background: #E9F4FF;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #323232;
  text-align: center;
  border-radius: 12px;
  margin-bottom: 32px;
  padding: 16px 12px;
  > span {
    font-weight: 800;
  }
  @media screen and (max-width: 450px) {
    max-width: 330px;
    margin-bottom: 10px;
  }
`;

export const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 50px;
  display: flex;
  width: 100%;
  max-width: 327px;
  position: relative;
  @media screen and (max-width: 300px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;
